import React from "react";

const OrderTitle = () => {
  return (
    <section className="hotel-header">
      <header className="hotel-header__title">
        <h1>{I18n.t("js.order.title")}</h1>
      </header>
    </section>
  );
}

export default OrderTitle;
